/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class JackpotParser {

    static parse(cfg) {
        const timestamp = cfg.bridge.timestamp;

        if (!cfg.jackpotPanel) {
            cfg.jackpotPanel = {
                enabled: false,
                basePath: `${cfg.game.preconfig.cdn}../../widgets/jackpots/base-jackpot/`,
                main: 'app.js',
                styles: 'app.css',
                timestamp,
                skin: 'base-jackpot',
                version: 'jackpotNext',
                hasShuffleAnimation: false,
                hasWinAnimation: false,
                feedUrl: `${cfg.bridge.feedUrl}/`,
                assets: 'assets/'
            };
        }

        if (!cfg.jackpotPanel.feedUrl) {
            cfg.jackpotPanel.feedUrl = `${cfg.bridge.feedUrl}/`;
        }

        if (!cfg.jackpotPanel.timestamp) {
            cfg.jackpotPanel.timestamp = timestamp;
        }

        cfg.jackpotPanel.feedInterval = 30; // seconds


        return cfg.jackpotPanel;
    }

    static parseWheel(cfg) {
        const timestamp = cfg.bridge.timestamp;

        cfg.jackpotWheel = {
            enabled: false,
            basePath: 'games/scenes/jackpot-wheels/base-wheel/',
            cdn: `${cfg.game.preconfig.cdn}../../../`,
            skin: 'base-wheel',
            wheelWinOnly: true,
            timestamp
        };

        return cfg.jackpotWheel;
    }

}


module.exports = JackpotParser;
